// client/menu-items/EditSelectedNode.ts
import { constructValue } from "@adornis/baseql/entities/construct.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { EditorDrawerPanel } from "../editor-drawer-panel.js";
import "../types.js";
import { isNodeSelection, updateNodeAttrs } from "../util.js";
var EditSelectedNodeMenuItem = ({
  editors,
  globalSettingsClassName,
  sizeBreakpoints
}) => ({
  label: "Bearbeiten",
  icon: "edit",
  run: async (view) => {
    console.log("RUN EDIT", { globalSettingsClassName, sizeBreakpoints });
    const { state, dispatch } = view;
    if (!isNodeSelection(state.selection))
      return;
    const node = state.selection.node;
    const editor = editors[node.type.name];
    if (!editor)
      throw new Error(`no editor for name ${node.type.name} found`);
    const dataString = node.attrs.data;
    if (!dataString)
      throw new Error("no data on item type " + node.type.name + " found.");
    const dataContent = constructValue(JSON.parse(dataString));
    await EditorDrawerPanel.showPopup({
      props: {
        dataContent,
        editor,
        globalSettingsClassName,
        sizeBreakpoints
      }
    }).then((res) => {
      if (!res)
        return;
      dispatch(
        updateNodeAttrs(state, state.tr.setMeta("onNodeChange", true), () => state.selection.from, {
          data: JSON.stringify(res.toObject())
        })
      );
    });
  },
  shouldVisualize: (view) => {
    return isNodeSelection(view.state.selection) && !!editors[view.state.selection.node.type.name];
  }
});
export {
  EditSelectedNodeMenuItem
};
